"use strict";

exports.__esModule = true;
exports.mapOOIStylesToManifestStyles = exports.mapOOISettingsToManifestData = exports.mapOOIPresetsToManifestPresets = exports.mapOOIGroupingsToManifestDisplayGroups = exports.isNumericType = void 0;
var _metadata = require("../types/metadata");
var _conversionUtils = require("./conversion-utils");
var _types = require("./types");
const NUMERIC_STYLE_TYPES = new Set([_metadata.StyleType.width, _metadata.StyleType.height, _metadata.StyleType.fontSize, _metadata.StyleType.lineHeight, _metadata.StyleType.letterSpacing, _metadata.StyleType.borderWidth, _metadata.StyleType.borderRadius, _metadata.StyleType.borderTopLeftRadius, _metadata.StyleType.borderTopRightRadius, _metadata.StyleType.borderBottomLeftRadius, _metadata.StyleType.borderBottomRightRadius, _metadata.StyleType.borderStartStartRadius, _metadata.StyleType.borderStartEndRadius, _metadata.StyleType.borderEndStartRadius, _metadata.StyleType.borderEndEndRadius, _metadata.StyleType.numberEnum, _metadata.StyleType.number]);
const isNumericType = type => NUMERIC_STYLE_TYPES.has(type);
exports.isNumericType = isNumericType;
const mapOOIStylesToManifestStyles = (params, {
  isMobile,
  paramsData = {}
}) => {
  const styles = {};
  for (const [key, {
    metadata,
    key: DMKey
  }] of Object.entries(params)) {
    const param = paramsData[key] || {};
    const {
      displayName
    } = param;
    const styleItem = (0, _conversionUtils.mapParamToItem)({
      metadata,
      params,
      isMobile: isMobile ?? false,
      validate: type => type in _metadata.StyleType,
      createItem: (type, defaultValue) => {
        const item = {
          cssPropertyType: type,
          ...(typeof isMobile === 'boolean' && {
            defaultValue
          }),
          ...(displayName && {
            displayName
          })
        };
        if (type === _metadata.StyleType.stringEnum) {
          item.customEnum = {
            cssDataType: _types.CssDataTypeEnum.string,
            options: param.options
          };
        } else if (type === _metadata.StyleType.numberEnum) {
          var _param$options;
          item.customEnum = {
            cssDataType: _types.CssDataTypeEnum.number,
            options: (_param$options = param.options) == null ? void 0 : _param$options.map(o => ({
              value: String(o.value),
              displayName: o.displayName
            }))
          };
        } else if (isNumericType(type)) {
          item.number = param.options;
        }
        return item;
      }
    });
    if (styleItem) {
      styles[DMKey ?? key] = styleItem;
    }
  }
  return styles;
};
exports.mapOOIStylesToManifestStyles = mapOOIStylesToManifestStyles;
const mapOOISettingsToManifestData = (params, {
  isMobile,
  paramsData = {}
}) => {
  const data = {};
  for (const [key, {
    metadata,
    key: DMKey
  }] of Object.entries(params)) {
    const param = paramsData[key] || {};
    const {
      displayName
    } = param;
    const dataItem = (0, _conversionUtils.mapParamToItem)({
      metadata,
      params,
      isMobile: isMobile ?? false,
      validate: type => type in _metadata.DataType,
      createItem: (type, defaultValue) => {
        const item = {
          dataType: type,
          ...(typeof isMobile === 'boolean' && {
            defaultValue
          }),
          ...(displayName && {
            displayName
          }),
          ...((metadata == null ? void 0 : metadata.dataItemManifestData) || {})
        };
        if (type === _metadata.DataType.textEnum) {
          item.textEnum = {
            options: param.options
          };
        } else if (type === _metadata.DataType.number) {
          item.number = param.options;
        }
        return item;
      }
    });
    if (dataItem) {
      data[DMKey ?? key] = dataItem;
    }
  }
  return data;
};
exports.mapOOISettingsToManifestData = mapOOISettingsToManifestData;
const mapOOIGroupingToManifestDisplayGroupItem = (type, restOfGrouping) => {
  switch (type) {
    case 'presets':
      return {
        preset: {
          items: restOfGrouping.presets
        }
      };
  }
  return {};
};
const mapOOIGroupingTypeToManifestGroupType = type => {
  switch (type) {
    case 'presets':
      return _types.GroupType.preset;
    default:
      throw new Error(`unsupoorted groupType: ${type}`);
  }
};
const mapOOIGroupingsToManifestDisplayGroups = params => params.reduce((acc, {
  id,
  type,
  displayName,
  ...restOfGrouping
}) => ({
  ...acc,
  [id]: {
    groupType: mapOOIGroupingTypeToManifestGroupType(type),
    displayName,
    ...mapOOIGroupingToManifestDisplayGroupItem(type, restOfGrouping)
  }
}), {});
exports.mapOOIGroupingsToManifestDisplayGroups = mapOOIGroupingsToManifestDisplayGroups;
const mapOOIBreakpointStyleToManifestBreakpointStyle = style => Object.fromEntries(Object.entries(style).map(([key, value]) => [key, {
  value
}]));
const mapOOIStyleToManifestStyleOverrides = breakpointStyles => Object.fromEntries(Object.entries(breakpointStyles).map(([breakpoint, style]) => [breakpoint, {
  cssCustomProperties: mapOOIBreakpointStyleToManifestBreakpointStyle(style)
}]));
const mapOOIPresetStyleToManifestPresetStyleOverrides = styleOverrides => {
  const {
    default: defaultStyle,
    ...breakpointStyles
  } = styleOverrides;
  return {
    default: {
      cssCustomProperties: mapOOIBreakpointStyleToManifestBreakpointStyle(defaultStyle)
    },
    ...mapOOIStyleToManifestStyleOverrides(breakpointStyles)
  };
};
const mapOOIPresetOptimizedForToManifestOptimizedFor = optimizedFor =>
// @ts-expect-error - TODO: mappers provide mismatched types, remove this once the mappers are fixed (need to use BreakpointEnumBreakpoint from component-protocol - not yet exported)
(optimizedFor == null ? void 0 : optimizedFor.map(breakpoint => breakpoint.valueOf())) ?? [];
const mapOOIPresetsToManifestPresets = params => params.reduce((acc, {
  id,
  style,
  optimizedFor,
  ...resetOfPresetConfig
}) => ({
  ...acc,
  [id]: {
    ...resetOfPresetConfig,
    ...(optimizedFor ? {
      optimizedFor: mapOOIPresetOptimizedForToManifestOptimizedFor(optimizedFor)
    } : {}),
    styleOverrides: mapOOIPresetStyleToManifestPresetStyleOverrides(style)
  }
}), {});
exports.mapOOIPresetsToManifestPresets = mapOOIPresetsToManifestPresets;
//# sourceMappingURL=manifest-mappers.js.map